import { useEffect, useState } from "react";

import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Tooltip } from "antd";
import { LngLatLike } from "mapbox-gl";
import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { useMapStore } from "stores/map";

import { DEFAULT_LATITUDE, DEFAULT_LONGITUDE } from "models/mapDefaults";

import { BaseDropdown, ToolbarButton } from "components/base";

import { useMapContext } from "../hooks/useMapContext";

export default function ZoomControl() {
  const { mapbox } = useMapContext();
  const setMapState = useMapStore((s) => s.setMapState);
  const [selectedZoom, setSelectedZoom] = useState("Province/State");
  useEffect(() => {
    if (!mapbox) {
      return;
    }
    const subscription = fromEvent(mapbox, "zoom")
      .pipe(debounceTime(1000))
      .subscribe(() => {
        const currZoom = mapbox.getZoom();
        findNewZoomLabel(currZoom);
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [mapbox]);

  function handleZoomDropdownChange({ label, value }) {
    const newZoom = value;
    let center = mapbox.getCenter() as LngLatLike;
    if (selectedZoom === "World") {
      center = [DEFAULT_LONGITUDE, DEFAULT_LATITUDE];
    }
    if (label === "Continent") center = [-100.39382659300577, 51.55723251975266];
    mapbox.flyTo({
      center,
      zoom: newZoom
    });
    const newMapState = {
      lng: center[1],
      lat: center[0],
      zoom: newZoom
    };
    setMapState(newMapState);
  }
  function findNewZoomLabel(zoom) {
    let opt = "";
    const options = [...zoomOptions, { label: "INF", value: 9999 }];
    for (let k = 0; k < options.length; k++) {
      if (zoom >= options[k].value && zoom <= options[k + 1].value) {
        opt = options[k].label;
      }
    }
    setSelectedZoom(opt);
  }
  function handleZoomIncrease() {
    if (!mapbox) {
      return;
    }
    mapbox.zoomIn({ duration: 1000 });
    const newZoom = mapbox.getZoom();
    findNewZoomLabel(newZoom);
  }

  function handleZoomDecrease() {
    mapbox.zoomOut({ duration: 1000 });
    const newZoom = mapbox.getZoom();
    findNewZoomLabel(newZoom);
  }
  if (!mapbox) {
    return <></>;
  }
  return (
    <Tooltip title="Zoom Level" placement="bottom">
      <div className="zoom-control">
        <div className="flex-row">
          <ToolbarButton
            active={false}
            icon={<AddIcon fontSize="large" />}
            onToggle={handleZoomIncrease}
          />
          <BaseDropdown
            value={selectedZoom}
            onChange={handleZoomDropdownChange}
            options={zoomOptions}
          />
          <ToolbarButton
            active={false}
            icon={<RemoveIcon fontSize="large" />}
            onToggle={handleZoomDecrease}
          />
        </div>
      </div>
    </Tooltip>
  );
}
const zoomOptions = [
  { label: "World", value: 0 },
  { label: "Continent", value: 3 },
  { label: "Province/State", value: 5 },
  { label: "Region", value: 7 },
  { label: "Area", value: 9 },
  { label: "Township", value: 10 },
  { label: "Section", value: 11 }
];
